import { NgModule } from '@angular/core';
import { AngularUpgradeHelper } from '../helpers/AngularUpgradeHelper';
import { HighchartsComponent } from './highcharts.component';

@NgModule({
    declarations: [
        HighchartsComponent
    ],
    entryComponents: [
        HighchartsComponent
    ],
    exports: [
        HighchartsComponent
    ],
})
export class HighchartsModule {
    private commonModuleName = 'app.areas.commonModule';

    constructor() {
        AngularUpgradeHelper.downgradeComponents(this.commonModuleName, [
            HighchartsComponent,
        ]);
    }
}
